import { clamp } from '../geometry';
import type { Rect, Transform } from '../types';

/** Default share of extra space around the bounds (v11). */
export const DEFAULT_BOUNDS_PADDING = 0.1;

const HALF = 0.5;

/**
 * Viewport that fits `bounds` into a `width` × `height` area, centred, with `padding` as a share of
 * the bounds size (v11 `getTransformForBounds`). Zoom is clamped to [minZoom, maxZoom].
 */
export const getTransformForBounds = (
  bounds: Readonly<Rect>,
  width: number,
  height: number,
  minZoom: number,
  maxZoom: number,
  padding = DEFAULT_BOUNDS_PADDING,
): Transform => {
  const zoom = clamp(
    Math.min(width / (bounds.width * (1 + padding)), height / (bounds.height * (1 + padding))),
    minZoom,
    maxZoom,
  );
  const centerX = bounds.x + bounds.width * HALF;
  const centerY = bounds.y + bounds.height * HALF;
  return [width * HALF - centerX * zoom, height * HALF - centerY * zoom, zoom];
};

